module.exports = __webpack_public_path__ + "280f5562771525476160e49c47c6770c.png";